var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category',{attrs:{"name":"Health & Hunger","categorystyle":"health_category"}},[_c('block',{attrs:{"type":"full_heal"}}),_c('block',{attrs:{"type":"kill_player"}}),_c('block',{attrs:{"type":"change_health"}}),_c('block',{attrs:{"type":"set_max_health"}}),_c('block',{attrs:{"type":"set_hunger_level"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }